import React from 'react'
import { Select } from '@resurs/midas-react'

export class FormSelect extends React.PureComponent {
  constructor(props) {
    super(props)
    let defaultValueIndex = -1
    if (this.props.defaultValue) {
      defaultValueIndex = this.props.values.findIndex(option =>
        [option.value, option.label]
          .map(s => `${s}`.toLowerCase())
          .includes(`${this.props.defaultValue}`.toLowerCase()),
      )
    }
    this.state = {
      defaultValueIndex: defaultValueIndex !== -1 ? defaultValueIndex : 0,
    }
  }

  componentDidMount() {
    if (!this.props.optionsLabel) {
      this.onChange(this.props.values[this.state.defaultValueIndex].value)
    }
  }

  onChange(value) {
    this.props.isValid({
      key: this.props.id,
      valid:
        this.props.values.findIndex(option => option.value === value) !== -1,
    })
    this.props.onChange(value)
  }

  render() {
    return (
      <Select
        {...this.props}
        value={this.props.defaultValue}
        onChange={val => this.onChange(val)}
      />
    )
  }
}
